<template>
  <b-button
      :type="buttonType"
      class="is-small"
      @click="handleClick"
      :disabled="disabled"
  >{{buttonLabel}}</b-button>
</template>

<script>
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: { BButton },
    name: "action-button",
    props: ['type', 'label', 'disabled', 'onClick'],
    computed: {
      buttonType() {
        return this.type ? this.type : 'is-success';
      },
      buttonLabel() {
        return this.label ? this.label : 'Action';
      }
    },
    methods: {
      handleClick() {
        if (typeof this.onClick === 'function') {
          this.onClick();
        }
      }
    }
  }
</script>

<style scoped>

</style>